import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a logging function

const sendRequest = async (oid, message, email, phone, type, token, prefix) => {
  const url = prefix + `support/request`;

  let body = {
    message: message,
    email: email,
    phone: phone,
    type: type,
    oid: oid,
  };

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    // Make the POST request using fetch instead of axios
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    if (!currentUser) {
      console.error("User not logged in");
      return;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");

    const responseData = await response.json();

    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body
      JSON.stringify(responseData) // response body
    );

    // Check if the request was successful
    if (response.ok) {
    } else {
      console.error(`Failed to send request: ${response.status}`);
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default sendRequest;
